<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-10-08 15:37:03
 * @LastEditors: Tan Chao
 * @LastEditTime: 2022-07-11 14:34:50
-->
<template>
	<div class="verified-member-content-setting">
		<div class="border f14"><span style="color: red">*</span> {{ schema.label }}</div>
		<div class="content-setting">
			<div class="nav">
				<config-item label="标题">
					<el-input v-model="value[0].label" autosize type="textarea" style="width: 100%" size="small"> </el-input>
				</config-item>
				<config-item label="会员列表">
					<el-select v-model="value[0].list" multiple placeholder="全部" size="small">
						<el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</config-item>
				<config-item label="行业分类">
					<el-select v-model="value[0].industry_category" multiple placeholder="全部" size="small">
						<el-option v-for="item in category.list" :key="item.id" :label="item.name" :value="item[category.industry_config == 1 ? 'id' : 'code']"> </el-option>
					</el-select>
				</config-item>
				<config-item :label="item.title" v-for="(item, index) in value[0].expand_field" :key="index">
					<el-select v-model="item.value" multiple placeholder="全部" size="small" @change="expandChange">
						<el-option v-for="(e, i) in item.content" :key="i" :label="e.value" :value="e.key"> </el-option>
					</el-select>
				</config-item>
			</div>
		</div>
	</div>
</template>

<script>
import schemaMixin from '@/mixin/schemaMixin';
import { getVip, getIndustryCategory, getV1_extend } from '@/api/goods';

export default {
	name: 'SchemaVerifiedMemberContentSetting',
	mixins: [schemaMixin],
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		schema: {
			type: Object,
			default: () => {},
		},
		child: {
			type: Object,
			default: () => {},
		},
	},

	data() {
		return {
			show: false,
			mValue: [],
			list: [],
			category: {},
			extend_list: [],
		};
	},

	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				this.mValue = newValue;
			},
		},

		mValue: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				this.$emit('input', newValue);
			},
		},
	},
	created() {
		console.log(666, this.mValue, this.schema, this.value);
		this.getList();
		this.getindustry();
		this.v1_extend();
	},
	methods: {
		async getList() {
			const res = await getVip();
			if (res.code == 200) {
				this.list = res.data;
			}
		},
		async getindustry() {
			const res = await getIndustryCategory();
			this.category = res.data;
		},
		async v1_extend() {
			const res1 = await getV1_extend({ type: 1 });
			const res2 = await getV1_extend({ type: 2 });
			const extend = [];
			res1.data.forEach((e) => {
				e.list.forEach((e2) => {
					extend.push(e2);
				});
			});
			res2.data.forEach((e) => {
				e.list.forEach((e2) => {
					extend.push(e2);
				});
			});
			function uniqueByField(arr, key) {
				return [...new Map(arr.map((item) => [item[key], item])).values()];
			}
			const result = uniqueByField(extend, 'name');
			// console.log(66633333, res1.data, res2.data, extend, result);

			this.extend_list = result.filter((e) => e.is_miniapp_filter == 1);
			const expand_field_list = this.extend_list.map((e) => {
				return { title: e.title, name: e.name, content: e.content, value: '' };
			});

			expand_field_list.forEach((item) => {
				this.value[0].expand_field.forEach((item1) => {
					if (item.name == item1.name) {
						item.value = item1.value;
					}
				});
			});

			this.value[0].expand_field = expand_field_list;

			this.$forceUpdate();
		},
		expandChange() {
			this.mValue = JSON.parse(JSON.stringify(this.value));
			this.$forceUpdate();
		},
	},
};
</script>

<style lang="scss" scoped>
.verified-member-content-setting {
	padding: 0 10px;
	.content-setting {
		padding: 10px;
		.nav {
			border-radius: 2px;
			box-shadow: 0 0.05333333rem 0.10666667rem rgba(0, 0, 0, 0.1);
		}
	}
}
</style>
